import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-detail",
  "use": "icon-detail-usage",
  "viewBox": "0 0 1194 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1194 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-detail\"><defs><style type=\"text/css\"></style></defs><path d=\"M597.333333 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m0-914.2784A402.2784 402.2784 0 1 0 999.611733 512 402.2784 402.2784 0 0 0 597.333333 109.7216z m77.585067 583.304533a109.7216 109.7216 0 0 1-155.153067 0l-103.441066-103.441066a109.7216 109.7216 0 0 1 0-155.153067l103.441066-103.441067a109.7216 109.7216 0 0 1 155.153067 0l103.441067 103.441067a109.7216 109.7216 0 0 1 0 155.153067z m25.856-206.882133l-77.585067-77.585067a36.573867 36.573867 0 0 0-51.729066 0l-77.585067 77.585067a36.573867 36.573867 0 0 0 0 51.729067l77.585067 77.585066a36.573867 36.573867 0 0 0 51.729066 0l77.585067-77.585066a36.573867 36.573867 0 0 0 0-51.729067z\" p-id=\"42481\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/detail.svg
// module id = mQDj
// module chunks = 34